module.exports = __webpack_public_path__ + "static/media/animal_04.bd48e2ca.png";